<h2 class="social-dialog-title" mat-dialog-title>{{ data.modalTitle }}</h2>
<mat-dialog-content>
  <div class="form-container" [formGroup]="formGroup" style="padding-top: 16px">
    <mat-form-field hideRequiredMarker="true">
      <input matInput placeholder="First Name" aria-label="First Name" formControlName="firstName" required />
      <mat-error>First name is required.</mat-error>
    </mat-form-field>
    <mat-form-field hideRequiredMarker="true" style="margin-top: 16px">
      <input matInput placeholder="Last Name" aria-label="Last Name" formControlName="lastName" required />
      <mat-error>Last name is required.</mat-error>
    </mat-form-field>
  </div>
  <div class="center-element">
    <button
      mat-raised-button
      (click)="updateUser()"
      [disabled]="!formGroup?.valid"
      class="social-modal-buttons social-modal-button-primary"
    >
      Done
    </button>
  </div>
</mat-dialog-content>
